/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import * as find from 'lodash/find';
import * as get from 'lodash/get';
import * as sortBy from 'lodash/sortBy';
import '../css/About.css';
import '../css/AddVehicle.css';
import { Row } from 'react-bootstrap';
// import MyUtil from '../../functions/MyUtil';
import UserApi from '../../functions/api/user/UserApi';
import UserGroupApi from '../../functions/api/user/UserGroupApi';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import ConvertUser from '../../functions/ConvertUser';
import NotifyError from '../../components/Notify/NotifyError';
// import moment from 'moment'
// import debounce from "lodash.debounce";

class FormAddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        user_acc_emai: '',
        user_acc_full_name: '',
        user_acc_name: '',
        user_acc_phon: '',
        user_group_id: '',
      },
      role: [
        { value: 2, label: 'CX-User' },
        { value: 3, label: 'Đối tác' },
      ],
      roleSelected: { value: 2, label: 'CX-User' },
      partners: [],
      userGroups: [],
      partnerSelected: { label: 'Chọn đối tác cần map', value: 0 },
      userGroupSelected: { label: 'Chọn user group', value: null },
      isEdit: false,
      editPassword: false,
      inputPassword: '',
    };
  }

  componentDidMount = async () => {
    const { match } = this.props;

    let listPartner = await PartnerApi.getAll();
    listPartner = sortBy(listPartner, ['part_name']);
    const partners = [];
    listPartner.forEach((partner) => {
      partners.push({
        ...partner,
        value: partner.part_id,
        label: partner.part_name,
      });
    });
    partners.unshift({ value: 0, label: 'Chọn đối tác cần map' });
    await this.setState({ partners });

    const listUserGroup = await UserGroupApi.getAllUserGroup();
    const userGroups = [];
    listUserGroup.forEach((userGroup) => {
      userGroups.push({
        ...userGroup,
        value: userGroup.user_group_id,
        label: userGroup.user_group_name,
      });
    });
    userGroups.unshift({ value: null, label: 'Chọn user group' });
    await this.setState({ userGroups });

    if (match.params && match.path === '/user/edit/:user_id') {
      const { user_id: userId } = match.params;
      let user = await UserApi.getUserById(userId, false);
      console.log('user ', user);
      user = user.data;
      const currentPartner = user.user_part_id
        ? find(partners, { part_id: user.user_part_id })
        : [];
      const partnerSelected = {
        value: get(currentPartner, 'part_id', 0),
        label: get(currentPartner, 'part_name', 'Chọn đối tác cần map'),
      };
      const roleSelected = {
        value: user.user_role_id,
        label: user.user_role_id === 2 ? 'CX-User' : 'Đối tác',
      };
      const currentUserGroup = user.user_group_id
        ? find(userGroups, { user_group_id: user.user_group_id })
        : [];
      const userGroupSelected = {
        value: get(currentUserGroup, 'user_group_id', null),
        label: get(currentUserGroup, 'user_group_name', 'Chọn user group'),
      };
      this.setState({ user });
      this.setState({
        isEdit: true,
        partnerSelected,
        roleSelected,
        userGroupSelected,
      });
    }
  };

  handleChange = async (event) => {
    const { user } = this.state;
    user[event.target.name] = event.target.value;
    this.setState({ user });
  };

  handleInputPassword = async (event) => {
    this.setState({ inputPassword: event.target.value });
  };

  handleChangePartner = async (event) => {
    this.setState({ user_part_id: event.target.value });
  };

  enableChangePassword = async () => {
    this.setState({ editPassword: true });
  };

  handleChangePassword = async () => {
    const { user, inputPassword } = this.state;
    const params = {
      hashed_pass: user.user_acc_pass,
      user_id: user.user_acc_id,
      new_pass: inputPassword,
    };

    await UserApi.resetPassword(params)
      .then((response) => {
        this.setState({ editPassword: false });
        if (response.code === 'success')
          NotifyAlert('Thành công', `Thay đổi mật khẩu thành công.`);
        if (response.code === 'error')
          NotifyAlert('Thất bại', response.message);
      })
      .catch((err) => NotifyAlert('Lỗi', `Đã xảy ra lỗi khi xoá user! ${err}`));
  };

  cancelChangePassword = async () => {
    this.setState({ editPassword: false });
  };

  onChangeSelectRole = async (roleSelected) => {
    if (roleSelected.value === 2)
      this.setState({
        partnerSelected: { label: 'Chọn đối tác cần map', value: 0 },
      });
    this.setState({ roleSelected });
  };

  onChangeSelectPartner = async (partnerSelected) => {
    this.setState({ partnerSelected });
  };

  onChangeSelectUserGroup = async (userGroupSelected) => {
    this.setState({ userGroupSelected });
  };

  clearForm = () => {
    this.setState({
      user: {
        user_acc_emai: '',
        user_acc_full_name: '',
        user_acc_name: '',
        user_acc_phon: '',
      },
      roleSelected: { value: 2, label: 'CX-User' },
      partnerSelected: { label: 'Chọn đối tác cần map', value: 0 },
      userGroupSelected: { label: 'Chọn user group', value: null },
      inputPassword: '',
    });
  };

  handleCreate = async () => {
    const { check } = ConvertUser.handleCheck(this.state);
    const { isEdit } = this.state;
    // console.log('check ', check);
    if (!check) {
      let result = '';
      if (isEdit) {
        const user = ConvertUser.handleUpdate(this.state);
        result = await UserApi.update(user);
      } else {
        const user = ConvertUser.handleNew(this.state);
        result = await UserApi.register(user);
      }

      console.log('result ', result);
      if (result && !result.message) {
        let message = '';
        if (isEdit) message = 'Sửa user thành công!';
        else message = 'Thêm user thành công';

        NotifyAlert('Thành công', message);
        if (!isEdit) this.clearForm();
      } else {
        NotifyError('Lỗi', result.message);
      }
    } else {
      NotifyAlert('Thông báo', `Dữ liệu bạn nhập bị thiếu. Hãy kiểm tra lại.`);
    }
  };

  render() {
    const {
      user,
      partners,
      partnerSelected,
      isEdit,
      role,
      roleSelected,
      editPassword,
      inputPassword,
      userGroups,
      userGroupSelected,
    } = this.state;
    return (
      <div>
        <div
          style={{
            display: 'inline-flex',
            width: '90%',
            margin: '10px 10px 20px 21px',
          }}
        >
          <Link to="/user">
            <div className="button-back button">
              <img
                alt="Quay lại"
                src="ic_back.png"
                style={{ height: '20px' }}
              />
              <div style={{ fontSize: '16px' }}>Quay lại</div>
            </div>
          </Link>
          <div
            style={{
              color: '#107d82',
              fontWeight: '600',
              fontSize: '20px',
              marginLeft: '30%',
            }}
          >
            {isEdit ? 'Sửa user' : 'Thêm user'}
          </div>
        </div>

        <div
          style={{ backgroundColor: '#ececec', margin: '5px 20px 20px 20px' }}
        >
          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Username</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="user_acc_name"
                value={user.user_acc_name}
                placeholder="Nhập vào username"
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Mật khẩu</div>
              <input
                className={`input-normal ${!isEdit ? 'full-width' : ''}`}
                onChange={this.handleInputPassword}
                name="user_acc_pass"
                value={
                  isEdit && !editPassword ? user.user_acc_pass : inputPassword
                }
                placeholder={
                  editPassword ? 'Nhập mật khẩu mới' : 'Nhập mật khẩu'
                }
                disabled={isEdit && !editPassword}
                type={isEdit && !editPassword ? 'password' : 'text'}
              />

              {isEdit && !editPassword ? (
                <button
                  type="button"
                  className="btn-edit button"
                  style={{ marginLeft: 0 }}
                  onClick={this.enableChangePassword}
                >
                  Đổi mật khẩu
                </button>
              ) : null}
              {isEdit && editPassword ? (
                <span>
                  <button
                    type="button"
                    className="btn-cx button"
                    style={{ marginLeft: '5px' }}
                    onClick={this.handleChangePassword}
                  >
                    Change
                  </button>
                  <button
                    type="button"
                    className="btn-cx button"
                    style={{ marginLeft: '5px' }}
                    onClick={this.cancelChangePassword}
                  >
                    Cancel
                  </button>
                </span>
              ) : null}
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Fullname</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="user_acc_full_name"
                value={user.user_acc_full_name}
                placeholder="Nhập vào tên đầy đủ"
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Phone</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="user_acc_phon"
                value={user.user_acc_phon}
                placeholder="Nhập vào số điện thoại"
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Email</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="user_acc_emai"
                value={user.user_acc_emai}
                placeholder="Nhập vào email"
              />
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Loại User</div>
              <Select
                style={{ paddingLeft: '0px' }}
                className="select-vehicle full-width"
                classNamePrefix="select"
                defaultValue={role[0]}
                isLoading={false}
                isSearchable
                name="user_role_id"
                options={role}
                value={roleSelected}
                onChange={this.onChangeSelectRole}
              />
            </div>

            {roleSelected.value === 3 ? (
              <div className="row-child row-child-small">
                <div className="title-content-page">
                  Chọn đối tác cần map với user này
                </div>
                <Select
                  style={{ paddingLeft: '0px' }}
                  className="select-vehicle full-width"
                  classNamePrefix="select"
                  defaultValue={partners[0]}
                  isLoading={false}
                  isSearchable
                  name="partner"
                  options={partners}
                  value={partnerSelected}
                  onChange={this.onChangeSelectPartner}
                />
              </div>
            ) : null}

            {roleSelected.value === 2 ? (
              <div className="row-child row-child-small">
                <div className="title-content-page">
                  Chọn group phân quyền của User
                </div>
                <Select
                  style={{ paddingLeft: '0px' }}
                  className="select-vehicle full-width"
                  classNamePrefix="select"
                  defaultValue={userGroups[0]}
                  isLoading={false}
                  isSearchable
                  name="partner"
                  options={userGroups}
                  value={userGroupSelected}
                  onChange={this.onChangeSelectUserGroup}
                />
              </div>
            ) : null}
          </Row>
        </div>

        <Row
          style={{
            display: 'inline-flex',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <button
            type="button"
            className="btn-edit button btn-save"
            style={{ background: '#107d82' }}
            onClick={this.handleCreate}
          >
            Lưu thay đổi
          </button>
        </Row>
      </div>
    );
  }
}

export default FormAddUser;
